/* import __COLOCATED_TEMPLATE__ from './discovery-banner.hbs'; */
/* RESPONSIBLE TEAM: team-channels */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';

interface Args {}

export default class WhatsappDiscoveryBanner extends Component<Args> {
  @service declare intl: IntlService;
  @service declare intercomEventService: any;

  @action
  showBannerArticle(articleId: number, eventObject: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: eventObject,
      place: 'settings_channels_whatsapp',
      section: 'whatsapp_discovery_banner',
    });
    window.Intercom('showArticle', articleId);
  }

  @action
  showBannerConnectToWhatsappArticle() {
    this.showBannerArticle(5454490, 'banner_connect_to_whatsapp');
  }

  @action
  showBannerWhatsappUsageCostsArticle() {
    this.showBannerArticle(9061703, 'banner_whatsapp_usage_costs');
  }

  @action
  showBannerDeployFinOverChatArticle() {
    this.showBannerArticle(8286630, 'banner_deploy_fin_over_chat');
  }

  get bannerLinks() {
    return [
      {
        id: 'connect-to-whatsapp',
        text: this.intl.t('new-settings.channels.whatsapp.learn-more.whatsapp-channel'),
        onSelectItem: this.showBannerConnectToWhatsappArticle,
        href: 'https://www.intercom.com/help/en/articles/5454490-connect-your-whatsapp-channel',
      },
      {
        id: 'deploy-fin-over-chat',
        text: this.intl.t('new-settings.channels.whatsapp.learn-more.deploy-fin-over-chat'),
        onSelectItem: this.showBannerDeployFinOverChatArticle,
        href: 'https://www.intercom.com/help/en/articles/8286630-deploy-fin-ai-agent-over-chat',
      },
    ];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Channels::Whatsapp::DiscoveryBanner': typeof WhatsappDiscoveryBanner;
  }
}
